import { PatentOrderingKey } from "@/components/business/PatentContainer/Patent.types";
import { usePatentListFilterState } from "@stores/patentList";

import {
  ORDERING_TABLE,
  Ordering,
  TABLE_HEADER_LIST,
  TableHeaderList,
} from "../../../constants/PatentTable.constants";

interface UseHandlePatentTableOrderingReturn {
  tableHeaderList: TableHeaderList[];
  handleOrdering: (
    orderingTitle: PatentOrderingKey,
    ordering: Ordering,
  ) => void;
  getOrderingIcon: (ordering: Ordering) => string;
  checkIsOrdering: (ordering: Ordering) => boolean;
}

export const useHandlePatentTableOrdering =
  (): UseHandlePatentTableOrderingReturn => {
    const [patentListFilter, setPatentListFilter] =
      usePatentListFilterState();
    const { order } = patentListFilter;

    const tableHeaderList: TableHeaderList[] = TABLE_HEADER_LIST.map(
      (tableHeader) => {
        const orderingValue = order[tableHeader.orderingTitle] || "none";
        return {
          ...tableHeader,
          ordering: orderingValue,
        };
      },
    );

    const handleOrdering = (
      orderingTitle: PatentOrderingKey,
      ordering: Ordering,
    ) => {
      const updatedOrdering = ORDERING_TABLE[ordering];
      let updatedOrderObject = { ...order };

      if (orderingTitle in order) {
        delete updatedOrderObject[orderingTitle];
      }

      updatedOrderObject = {
        ...updatedOrderObject,
        [orderingTitle]: updatedOrdering,
      };

      if (updatedOrdering === "none") {
        delete updatedOrderObject[orderingTitle];
      }
      setPatentListFilter({
        ...patentListFilter,
        order: updatedOrderObject,
      });
    };

    const getOrderingIcon = (ordering: Ordering) => {
      if (ordering === "asc") return "▲";
      if (ordering === "desc") return "▼";
      return "";
    };

    const checkIsOrdering = (ordering: Ordering) => {
      if (ordering === "none") return false;
      return true;
    };

    return {
      tableHeaderList,
      handleOrdering,
      getOrderingIcon,
      checkIsOrdering,
    };
  };
